import React from 'react';
import { cx } from '@linaria/atomic';
import { Text, type TextProps } from '../../text/text.component';
import * as styles from '../index-row.styles';
import { useIndexRowItemContext } from './index-row-item';

type IndexRowTitleProps = {
  children: React.ReactNode;
} & TextProps;

export const IndexRowTitle = ({ children, className, ...rest }: IndexRowTitleProps) => {
  const { disabled } = useIndexRowItemContext();

  return (
    <>
      {typeof children === 'string' ? (
        <Text
          size='large'
          className={cx(styles.truncatedTextStyle, disabled && styles.halfOpacityStyle, className)}
          {...rest}
        >
          {children}
        </Text>
      ) : (
        children
      )}
    </>
  );
};

IndexRowTitle.displayName = 'IndexRowTitle';
